function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Fill, Stroke, Style, Text } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import MultiPoint from 'ol/geom/MultiPoint';
import { extractCoordinates } from '../utils/getCoordinates';
export var DrawStyleGeometry;

(function (DrawStyleGeometry) {
  DrawStyleGeometry["Polygon"] = "Polygon";
  DrawStyleGeometry["Point"] = "Point";
  DrawStyleGeometry["LineString"] = "LineString";
})(DrawStyleGeometry || (DrawStyleGeometry = {}));

export var mapStructToInstance = _ref => {
  var {
    text,
    image,
    stroke,
    fill,
    zIndex,
    displayVertices
  } = _ref;
  return text || image || stroke || fill || displayVertices ? new Style({
    zIndex: zIndex,
    stroke: stroke ? new Stroke(stroke) : undefined,
    fill: fill ? new Fill(fill) : undefined,
    text: text ? new Text(_objectSpread(_objectSpread({}, text), {}, {
      stroke: text.stroke ? new Stroke(text.stroke) : undefined,
      fill: text.fill ? new Fill(text.fill) : undefined,
      backgroundFill: text.backgroundFill ? new Fill(text.backgroundFill) : undefined
    })) : undefined,
    image: image ? new CircleStyle(_objectSpread(_objectSpread({}, image), {}, {
      stroke: image.stroke ? new Stroke(image.stroke) : undefined,
      fill: image.fill ? new Fill(image.fill) : undefined
    })) : undefined,
    geometry: displayVertices ? function (feature) {
      var type = feature.getGeometry().getType(); // For points use the existing geometry

      if (type === 'Point' || type === 'MultiPoint') {
        return feature.getGeometry();
      } // For other features styling the vertices extract coordinates from all geometry features and use new styled multi-point


      var coordinates = extractCoordinates(feature.getGeometry());
      return coordinates ? new MultiPoint(coordinates) : undefined;
    } : undefined
  }) : undefined;
};